import { faChild, faTimes, faUserPlus, faUsers } from '@fortawesome/free-solid-svg-icons';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import StatsItem from '../StatsItem';

class Stats extends Component {
	render() {
		const { loading, data, className, schoolYearId, t } = this.props;
		const { lessonCount, childrenCount, newChildrenCount, missedLessonCount } = data || { lessonCount: null, childrenCount: null, newChildrenCount: null, missedLessonCount: null };

		const comparisonLabel = schoolYearId ? t('SalesDashboard_SincePreviousYear') : t('SalesDashboard_SincePreviousPeriod');

		return <Row className={className}>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-green'
					label={t('OperationsDashboard_Stats_LessonCount')}
					icon={faUsers}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonCount}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-orange'
					label={t('OperationsDashboard_Stats_MissedLessonCount')}
					icon={faTimes}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...missedLessonCount}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-violet'
					label={t('OperationsDashboard_Stats_ChildrenCount')}
					icon={faChild}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...childrenCount}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-blue'
					label={t('OperationsDashboard_Stats_NewChildrenCount')}
					icon={faUserPlus}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...newChildrenCount}
				/>
			</Col>
		</Row >;
	}
}

export default withTranslation()(Stats);